import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';

const PaymentSuccess = () => {
  const { bookingId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const travelDate = queryParams.get('date');
  const travelTime = queryParams.get('time');
  const distance = parseFloat(queryParams.get('distance')) || 0;
  const fromCity = queryParams.get('from');
  const toCity = queryParams.get('to');
  const viaCitiesParam = queryParams.get('via');
  const viaCities = viaCitiesParam
    ? (viaCitiesParam.includes("|") ? viaCitiesParam.split("|") : [viaCitiesParam])
        .map((city) => city.trim())
        .filter((city) => city)
    : [];
  const pickupAddress = queryParams.get('pickupAddress');
  const dropAddress = queryParams.get('dropAddress');
  const cabName = queryParams.get('cabName');
  const amount = queryParams.get('amount');

  // Format route display with via cities
  const formatRoute = () => {
    if (viaCities.length > 0) {
      return `${fromCity} → ${viaCities.join(' → ')} → ${toCity}`;
    }
    return `${fromCity} → ${toCity}`;
  };
  
  return (
    <div className="container mx-auto py-12">
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-md p-8 text-center">
        <div className="inline-block p-4 rounded-full bg-green-100 mb-6">
          <svg className="h-16 w-16 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-3">Payment Successful!</h1>
        <p className="text-gray-600 mb-6">
          Your payment for booking #{bookingId} has been successfully processed.
          A confirmation has been sent to your email address.
        </p>
        
        <div className="border-t border-b py-6 mb-6">
          <p className="text-gray-600 mb-1">Transaction Reference</p>
          <p className="font-medium text-lg">{`TXN-${Math.floor(100000000 + Math.random() * 900000000)}`}</p>
        </div>
        
        <div className="border-t border-b py-4 mb-6 text-left">
          <h3 className="font-bold mb-2 text-center">Booking Details</h3>
          <div className="space-y-2 max-w-md mx-auto">
            <div className="flex justify-between">
              <span className="text-gray-600">Booking #:</span>
              <span className="font-medium">{bookingId || 'CB49974322'}</span>
            </div>
            {fromCity && toCity && (
              <div className="flex justify-between">
                <span className="text-gray-600">Route:</span>
                <span className="font-medium">{formatRoute()}</span>
              </div>
            )}
            {travelDate && travelDate !== 'undefined' && (
              <div className="flex justify-between">
                <span className="text-gray-600">Booked for:</span>
                <span className="font-medium">{new Date(travelDate).toLocaleDateString()}</span>
              </div>
            )}
            {travelTime && travelTime !== 'undefined' && (
              <div className="flex justify-between">
                <span className="text-gray-600">Pickup Time:</span>
                <span className="font-medium">{travelTime}</span>
              </div>
            )}
            {distance > 0 && (
              <div className="flex justify-between">
                <span className="text-gray-600">Distance:</span>
                <span className="font-medium">{Math.round(distance).toLocaleString('en-IN')} km</span>
              </div>
            )}
            {pickupAddress && (
              <div className="flex flex-col">
                <span className="text-gray-600 text-left">Pickup Address:</span>
                <span className="font-medium text-left">{pickupAddress}</span>
              </div>
            )}
            {dropAddress && (
              <div className="flex flex-col">
                <span className="text-gray-600 text-left">Drop Address:</span>
                <span className="font-medium text-left">{dropAddress}</span>
              </div>
            )}
            {cabName && (
              <div className="flex justify-between">
                <span className="text-gray-600">Cab Type:</span>
                <span className="font-medium">{cabName}</span>
              </div>
            )}
            {amount && (
              <div className="flex justify-between font-bold text-lg pt-2 border-t mt-2">
                <span className="text-gray-800">Total Amount Paid:</span>
                <span className="text-blue-600">₹{parseFloat(amount).toLocaleString('en-IN')}</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to={`/booking/${bookingId}`} className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700">
            View Booking Details
          </Link>
          <Link to="/dashboard" className="bg-gray-200 text-gray-800 px-6 py-3 rounded hover:bg-gray-300">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
